import axios from 'axios';

const PrismicDOM = require('prismic-dom');

class Footer {
  constructor() {
    const {
      globalConfig: { prismicApi },
    } = window;
    this.prismicApi = prismicApi;
    this.mediaDomain = '//media.blinds.com';
  }

  getCECHours() {
    axios.get(this.prismicApi).then((val) => {
      const { ref } = val.data.refs[0];
      axios
        .get(`${this.prismicApi}/documents/search`, {
          params: {
            ref,
            q: '[[at(document.type, "footer")]]',
          },
        })
        .then((footer) => {
          try {
            const { data } = footer.data.results[0];
            document.querySelector('#bc-footer-center').innerHTML = PrismicDOM.RichText.asHtml(data.center_column);
            document.querySelector('#bc-footer-right').innerHTML = PrismicDOM.RichText.asHtml(data.right_column);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error parsing footer data', e);
          }
        });
    });
  }
}

export default Footer;
